// Every language the website ships — the ONE list.
//
// The header switcher, the Settings picker, i18next's `supportedLngs` and the
// PWA manifests all read this. They used to keep a list each, and the Settings
// picker offered Arabic and English only for the two months French and German
// shipped (BUG-369). Adding a language is a row here, its catalogue in
// `src/locales/`, its `public/manifest.<code>.json`, and the backend and mobile
// lists `scripts/check_language_alignment.py` names.
//
// `shortLabel` is what the header shows for the CURRENT language; `nativeLabel`
// is the endonym — a language is always offered in its own name, because the
// person looking for it may not read the one on screen.

export const LANGUAGES = [
  { code: 'ar', shortLabel: 'ع', nativeLabel: 'العربية', dir: 'rtl' },
  { code: 'en', shortLabel: 'EN', nativeLabel: 'English', dir: 'ltr' },
  { code: 'fr', shortLabel: 'FR', nativeLabel: 'Français', dir: 'ltr' },
  { code: 'de', shortLabel: 'DE', nativeLabel: 'Deutsch', dir: 'ltr' },
  { code: 'es', shortLabel: 'ES', nativeLabel: 'Español', dir: 'ltr' },
  { code: 'tr', shortLabel: 'TR', nativeLabel: 'Türkçe', dir: 'ltr' },
  { code: 'id', shortLabel: 'ID', nativeLabel: 'Bahasa Indonesia', dir: 'ltr' },
  { code: 'ur', shortLabel: 'اردو', nativeLabel: 'اردو', dir: 'rtl' },
];

export const SUPPORTED_LANGUAGES = LANGUAGES.map((language) => language.code);
